import { render } from "./ErrorView.vue?vue&type=template&id=2fc9dad2&ts=true"
import script from "./ErrorView.vue?vue&type=script&lang=ts"
export * from "./ErrorView.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/olaria-preco/olaria-preco/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__